import { render, staticRenderFns } from "./AdminLinks.vue?vue&type=template&id=7a67b1c2&scoped=true"
import script from "./AdminLinks.vue?vue&type=script&lang=js"
export * from "./AdminLinks.vue?vue&type=script&lang=js"
import style0 from "./AdminLinks.vue?vue&type=style&index=0&id=7a67b1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a67b1c2",
  null
  
)

export default component.exports